import { render, staticRenderFns } from "./plans.vue?vue&type=template&id=4fe2076e&scoped=true"
import script from "./plans.vue?vue&type=script&lang=js"
export * from "./plans.vue?vue&type=script&lang=js"
import style0 from "./plans.vue?vue&type=style&index=0&id=4fe2076e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe2076e",
  null
  
)

export default component.exports